export enum EventType {
  SMS = 'Notification.CreatedSMS',
  SUB_BRANDING = 'Brand.SubBranding',
  APP_PUSH = 'Notification.CreatedPush',
  APP_PUSH_URL = 'Notification.GenericPushUrl',
}
